import { GetterTree } from "vuex";
import { SocialThemeWidgetState } from "../models/social-theme-widget-state";

export default <GetterTree<SocialThemeWidgetState, SocialThemeWidgetState>>{
    items (state) {
        if (Array.isArray(state.themeItems) && state.themeItems.length) {
            return state.themeItems.slice(0, state.maxAmount );
        }
        return [];
    }
}

